import { useEffect } from 'react';

import { useGlobalContext } from '@/context/global.context';
import useOptionsStore from '@/store/options.store';

export const useSyncOptions = (tramiteId: number) => {
	const { maestrosTramite, maestrosGeneric } = useGlobalContext();
	const setOptionsFromContext = useOptionsStore((state) => state.setOptionsFromContext);

	useEffect(() => {
		setOptionsFromContext(maestrosGeneric, maestrosTramite, tramiteId);
	}, [maestrosGeneric, maestrosTramite, tramiteId, setOptionsFromContext]);
};
